/**
 * KiekkoKingi section controller: simulator-systems
 * Kept external so the browser can defer and cache this code.
 */
(() => {
  const kkScript = document.currentScript;
  if (!kkScript) return;

  (() => {
        const rootId = kkScript.dataset.rootId;
        const sectionId = kkScript.dataset.sectionId;
        const destroy = (root) => {
          if (!root || !root.__kiekkokingiSystemsCleanup) return;
          root.__kiekkokingiSystemsCleanup.forEach((cleanup) => cleanup());
          root.__kiekkokingiSystemsCleanup = null;
          root.removeAttribute('data-systems-initialized');
        };
  
        const init = (root) => {
          if (!root || root.hasAttribute('data-systems-initialized')) return;
          root.setAttribute('data-systems-initialized', 'true');
  
          const cleanup = [];
          const videos = Array.from(root.querySelectorAll('[data-simulator-system-video]'));
          const autoplay = root.dataset.videoAutoplay === 'true';
          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
          const visibility = new Map();
  
          const reconcileVideo = (video) => {
            if (!autoplay || reducedMotion.matches || document.hidden || !visibility.get(video)) {
              if (autoplay) video.pause();
              return;
            }
            video.muted = true;
            const playPromise = video.play();
            if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(() => {});
          };
  
          let observer;
          if (videos.length && autoplay && 'IntersectionObserver' in window) {
            observer = new IntersectionObserver((entries) => {
              entries.forEach((entry) => {
                visibility.set(entry.target, entry.isIntersecting && entry.intersectionRatio >= 0.35);
                reconcileVideo(entry.target);
              });
            }, { threshold: [0, 0.35, 1] });
            videos.forEach((video) => {
              visibility.set(video, false);
              observer.observe(video);
            });
            cleanup.push(() => observer.disconnect());
          } else if (videos.length && autoplay) {
            videos.forEach((video) => {
              visibility.set(video, true);
              reconcileVideo(video);
            });
          }
  
          const reconcileAll = () => videos.forEach(reconcileVideo);
          document.addEventListener('visibilitychange', reconcileAll);
          cleanup.push(() => document.removeEventListener('visibilitychange', reconcileAll));
  
          const onReducedMotion = () => reconcileAll();
          if (typeof reducedMotion.addEventListener === 'function') {
            reducedMotion.addEventListener('change', onReducedMotion);
            cleanup.push(() => reducedMotion.removeEventListener('change', onReducedMotion));
          } else if (typeof reducedMotion.addListener === 'function') {
            reducedMotion.addListener(onReducedMotion);
            cleanup.push(() => reducedMotion.removeListener(onReducedMotion));
          }
  
          const onBlockSelect = (event) => {
            if (!event.detail || !event.detail.blockId) return;
            const item = root.querySelector(`[data-simulator-system="${event.detail.blockId}"]`);
            if (!item) return;
            item.scrollIntoView({ behavior: reducedMotion.matches ? 'auto' : 'smooth', block: 'nearest', inline: 'nearest' });
          };
          document.addEventListener('shopify:block:select', onBlockSelect);
          cleanup.push(() => document.removeEventListener('shopify:block:select', onBlockSelect));
          cleanup.push(() => videos.forEach((video) => video.pause()));
          root.__kiekkokingiSystemsCleanup = cleanup;
        };
  
        const onSectionLoad = (event) => {
          if (!event.detail || String(event.detail.sectionId) !== String(sectionId)) return;
          init(document.getElementById(rootId));
        };
        const onSectionUnload = (event) => {
          if (!event.detail || String(event.detail.sectionId) !== String(sectionId)) return;
          const root = event.target.querySelector('[data-kiekkokingi-simulator-systems]') || document.getElementById(rootId);
          destroy(root);
          document.removeEventListener('shopify:section:load', onSectionLoad);
          document.removeEventListener('shopify:section:unload', onSectionUnload);
        };
  
        init(document.getElementById(rootId));
        document.addEventListener('shopify:section:load', onSectionLoad);
        document.addEventListener('shopify:section:unload', onSectionUnload);
      })();
})();